import { Maybe } from 'maybeasy';

export interface License {
  id: number;
  licenseName: Maybe<string>;
  licenseTypeName: string;
  quantityAvailable: number;
  startOn: Date;
  endOn: Date;
}

export interface UnselectedLicense {
  kind: 'unselected';
}

export interface SelectedLicense {
  kind: 'selected';
  license: License;
}

export type SelectableLicense = UnselectedLicense | SelectedLicense;

export const createUnselectedLicense = (): UnselectedLicense => ({ kind: 'unselected' });

export const createSelectedLicense = (license: License): SelectedLicense => ({
  kind: 'selected',
  license,
});
